import { render, staticRenderFns } from "./UserEditDetailsView.vue?vue&type=template&id=f9ed5004&"
import script from "./UserEditDetailsView.vue?vue&type=script&lang=js&"
export * from "./UserEditDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports